import { IRequest } from '@r1-frontend/shared/types/IRequest';

/*
* Предавторизация карты клиента, с временным удержанием 1 рубля и последующей разблокировкой, с сохранением карты клиента.
* https://master.api-pay.sandbox.d2c.r-one.io/docs/v1#/Card/8470d0f60d933d5c627024257b9b614b
*/

export const addCard = (providerId: number, additionalParams = {}): IRequest => ({
    uri: '/card/add',
    withAuth: true,
    withProvider: true,
    method: 'POST',
    body: JSON.stringify(additionalParams),
    queryParams: {
        providerId,
    },
});
